import { render, staticRenderFns } from "./PickUser.vue?vue&type=template&id=4d5a4065&scoped=true"
import script from "./PickUser.vue?vue&type=script&lang=js"
export * from "./PickUser.vue?vue&type=script&lang=js"
import style0 from "./PickUser.vue?vue&type=style&index=0&id=4d5a4065&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5a4065",
  null
  
)

export default component.exports